import React from "react";
import Label from './LabelUtilsComponet'

const Question = ({ config, onChange }) => {
  return (
    <div className={config.classContainer}>
      <Label {...config} />
      <div className="div-checkbox-form">
        <div
          className={config.classInput}
          onClick={() => onChange(config.variable, !config.value, config.type)}
        >
          {
            !!config.value ?
              <i className="fas fa-toggle-on fa-1x5"></i> :
              <i className="fas fa-toggle-off fa-1x5" style={{color:'grey'}}></i>
          }
        </div>
      </div>
    </div>
  )
}

export default Question;
